<template>
  <div class="pdf3_main">
    <header>
      <div>
        <h6>{{ $t("pdf.text34") }}</h6>
        <p>: {{ dataList.account_name }}</p>
        <p></p>
      </div>
      <div>
        <h6>{{ $t("pdf.text35") }}</h6>
        <p>
          : {{ dataList.account_number }} -
          {{ account_type == 3 ? "USDT" : "USDC" }}
        </p>
        <p></p>
      </div>
      <div>
        <h6>{{ $t("pdf.text36") }}</h6>
        <p>: {{ dataList.opening_balance }}</p>
      </div>
      <div>
        <h6>{{ $t("pdf.text37") }}</h6>
        <p>: {{ dataList.ledger_balance }}</p>
      </div>
      <div>
        <h6>{{ $t("pdf.text38") }}</h6>
        <p>: {{ dataList.available_balance }}</p>
      </div>
    </header>
    <main>
      <table>
        <tr class="tr ant-table-row">
          <th>
            <p>{{ $t("pdf.text20") }}</p>
          </th>
          <th>
            <p>{{ $t("pdf.text21") }}</p>
          </th>
          <th>
            <p>{{ $t('bank_card.card_username') }}</p>
          </th>
          <th>
            <p>{{ $t("pdf.text22") }}</p>
          </th>
          <th>
            <p>{{ $t("pdf.text23") }}</p>
          </th>
          <th>
            <p>{{ $t("pdf.text24") }}</p>
          </th>
          <th>
            <p>{{ $t("pdf.text15") }}</p>
            <p>({{ $t("pdf.text25") }})</p>
          </th>
        </tr>
        <tr class="tr ant-table-row" v-for="(item, index) in list" :key="index">
          <td style="min-width: 120px;">{{ item.c_time | getDate }}</td>
          <td style="min-width: 230px;" v-html="item.type_name"></td>
          <td>{{ item.card_username||"-" }}</td>
          <td style="
          max-width: 90px;
          white-space: normal;
          word-break: break-all;
          ">{{ item.tx_id }}</td>
          <td>
            <span v-if="item.action == 11">
              {{ item.amount }}
            </span>
            <span v-else>-</span>
          </td>
          <td>
            <span v-if="item.action == 10">
              {{ item.amount }}
            </span>
            <span v-else>-</span>
          </td>
          <td>{{ item.balance }}</td>
        </tr>
        <tr class="ant-table-row none tr">
          <td></td>
          <td></td>
          <td>
            <h6>
              <p>{{ $t("pdf.text12") }}</p>
              <p>{{ $t("pdf.text39") }}</p>
            </h6>
          </td>
          <td>
            <h6>{{ dataList.totalWithdraw }}</h6>
            <h6>{{ dataList.withdrawCount }}</h6>
          </td>
          <td>
            <h6>{{ dataList.totalDeposit }}</h6>
            <h6>{{ dataList.depositCount }}</h6>
          </td>
          <td></td>
        </tr>
        
      </table>
    </main>
    <footer class="ant-table-row">
      <p>**{{ $t("pdf.text40") }}**</p>
    </footer>
  </div>
</template>

<script>
import { dateFormat } from "../../assets/function/ch_time";
export default {
  filters: {
    getDate(v) {
      return dateFormat(v, "d/m/Y");
    },
  },
  props: {
    dataList: {
      default: {},
    },
    list: {
      default: [],
    },
    account_type: {
      default: "",
    },
    // t_h_time: {},
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    getDate2(v) {
      return dateFormat(new Date(v).getTime(), "d/m/Y");
    },
  },
  watch: {},
};
</script>

<style scoped lang="less">
/* a4纸的尺寸[595.28,841.89] */
footer {
  margin-top: 20px;
}
h5 {
  font-size: 22px;
}
h6 {
  font-size: 18px;
}
h4 {
  font-size: 16px;
  margin-top: 20px;
}
.pdf3_main {
  font-size: 14px;
  margin: 10px 30px;
  padding-bottom: 20px;
  // transform: scale(0.5);
  .headerLogo {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 100px;
      margin-bottom: 30px;
    }
  }
  header {
    border: 1px solid black;
    border-radius: 5px;
    padding: 10px;
    div {
      display: flex;
      justify-content: space-between;
      margin: 6px 0;
      h6 {
        width: 200px;
        font-size: 15px;
      }
      p:nth-child(2) {
        flex: 1;
      }
    }
  }

  main {
    margin-top: 20px;
    .tableHeader {
      margin-top: 20px;
      background: #00263a;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      color: white;
      font-weight: bold;
      align-items: center;
      p {
        margin: 10px;
        font-size: 16px;
      }
    }
    .tableHeader2 {
      // display: inline-block;
      // width: auto;
      // color: white;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      .tr th {
        border-bottom: 1px solid #000;
        padding: 5px;
        text-align: right;
        width: 13%;
      }
      tr td {
        text-align: right;
        width: 13%;
      }
      .tr th {
        background: #d0d3d4;
        padding: 5px;
      }
      tr:nth-child(odd) {
        background: #f5f6f6;
      }
      .none {
        background: white !important;
        h6 {
          padding: 0;
        }
      }
      tr td,
      tr h6 {
        padding: 5px;
        font-size: 14px;
      }
      tr td:nth-child(1) {
        text-align: left;
        width: 10%;
      }
      tr td:nth-child(2) {
        text-align: left;
        width: 20%;
      }
      tr td:nth-child(3) {
        text-align: left;
        width: 28%;
      }
      tr td:nth-child(6) {
        text-align: right;
        width: 16%;
      }
      tr th:nth-child(1) {
        text-align: left;
        width: 10%;
      }
      tr th:nth-child(2) {
        text-align: left;
        width: 20%;
      }
      tr th:nth-child(3) {
        text-align: left;
        width: 28%;
      }
      tr th:nth-child(6) {
        text-align: right;
        width: 16%;
      }
      .footer_tr td {
        padding-top: 20px;
      }
    }
  }
}
</style>
